export default "__VITE_ASSET__Bh_$4jM2__"